import { ItemType, TemplateItemOption } from "@/@types/flows/emailTemplates/items";

export const itemsToAddList: TemplateItemOption[] = [
  {
    type: ItemType.Text,
    name: "Texto",
    description: "Añade texto y personaliza su formato.",
  },
  {
    type: ItemType.Image,
    name: "Imagen",
    description: "Importa imágenes fijas a tu correo electrónico.",
  },
  {
    type: ItemType.Button,
    name: "Botón",
    description: "Añade CTA que redirijan a un link exerno",
  },
];
